// tslint:disable:max-line-length

import React from 'react';

export const ObjectFolder = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M0,1.2C0,1.1,0.1,1,0.2,1h5.5C5.9,1,6,1.1,6,1.2V3h10v2H0V1.2z M0,14.5V6h16v8.5c0,0.3-0.2,0.5-0.5,0.5h-15 C0.2,15,0,14.8,0,14.5z" />
    </svg>
  );
};
